module.exports = __webpack_public_path__ + "img/logo.91df9647.png";